<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="forms"
      :sort-by="[{ key: 'idClass', order: 'asc' }]"
      class="elevation-1"
      :search="search"
    >
      <!-- eslint-disable -->
      <!-- <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.descricao }}</td>
  
            <td> -->
      <!-- <v-tooltip
                text="Desabilitar usuário"
                location="bottom"
                v-if="item.raw.ativo"
              >
                <template v-slot:activator="{ props }">
                  <v-icon
                    v-bind="props"
                    size="small"
                    class="me-2"
                    @click="modalDesabilitar(item.raw)"
                  >
                    mdi-account-off
                  </v-icon>
                </template>
              </v-tooltip> -->
      <!-- <v-tooltip text="Reativar usuário" location="bottom" v-else>
                <template v-slot:activator="{ props }">
                  <v-icon
                    v-bind="props"
                    size="small"
                    class="me-2"
                    @click="modalReativar(item.raw)"
                  >
                    mdi-account-reactivate
                  </v-icon>
                </template>
              </v-tooltip>
              <v-tooltip text="Excluir usuário" location="bottom">
                <template v-slot:activator="{ props }">
                  <v-icon
                    v-bind="props"
                    size="small"
                    color="red"
                    @click="modalExcluir(item.raw)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-tooltip> -->
      <!--   </td>-->
      <!-- Outras colunas da tabela -->
      <!--  </tr>
        </template>-->

      <!-- eslint-enable -->
      <template #top>
        <v-toolbar flat>
          <v-btn
            style="background: #f9f8f8; font-size: 18px"
            size="small"
            @click="this.$router.go(-1)"
            icon
          >
            <v-icon color="#004984">mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title style="font-size: 22px; font-weight: bold"
            >Formulários</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>

          <div class="flex">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              outline
              hide-details
              variant="underlined"
              style="width: 40%"
            ></v-text-field>
            <div>
              <v-btn
                color="#004984"
                class="button-config"
                style="color: white"
                @click="cadastrarDialog = true"
              >
                Cadastrar Formulário
                <v-icon right style="margin-left: 5px">mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>

          <!--Visualizar formulário-->
          <v-dialog v-model="visualizarDialog" max-width="900px">
            <v-card>
              <v-card-title> Visualizar Formulário </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="this.editedItem.nomeFormulario"
                      label="Título do formulário"
                      variant="solo"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <p>Itens do formulário:</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <p
                      v-if="formsComQuestoes.length > 0"
                      v-for:="pergunta in formsComQuestoes"
                    >
                      <!-- <v-text-field
                        :value="pergunta.descricao"
                        variant="solo"
                        readonly
                      ></v-text-field> -->
                      <v-card>
                        <v-card-text>
                          {{ pergunta.descricao }}
                        </v-card-text>
                      </v-card>
                      <br />
                    </p>
                    <v-label v-else>Não há itens neste formulário</v-label>

                    <!-- <v-data-table
                      :headers="headers2"
                      :items="formsComQuestoes"
                      :sort-by="[{ key: 'descricao', order: 'asc' }]"
                      class="elevation-1"
                    ></v-data-table> -->
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- <v-btn
                  color="red"
                  variant="text"
                  @click="visualizarDialog = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="editarItem(editedItem)"
                >
                  Salvar
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Cadastrar formulário-->
          <v-dialog v-model="cadastrarDialog" scrollable width="900px">
            <v-card>
              <v-card-title> Cadastrar Formulário </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="nomeFormulario"
                        label="Título do Formulário*"
                        variant="outlined"
                        hint="Digite um nome para o formulário"
                        counter
                        maxlength="64"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <p>Selecione os itens que farão parte do formulário*</p>
                    </v-col>
                  </v-row>
                  <v-row class="my-2">
                    <v-col cols="12">
                      <v-data-table
                        v-model="itensSelecionados"
                        :headers="headers2"
                        :items="itens"
                        item-value="id"
                        hide-footer
                        show-select
                        class="elevation-1"
                      >
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
                <small>*Campos Obrigatórios</small>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  variant="text"
                  @click="cadastrarDialog = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="cadastrarItem"
                >
                  Cadastrar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!--Editar formulário-->
          <v-dialog v-model="editarDialog" max-width="750px">
            <v-card>
              <v-card-title> Editar Formulário </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col cols="10">
                    <v-text-field
                      v-model="editedItem.nomeFormulario"
                      label="Título do Formulário"
                      variant="outlined"
                      density="compact"
                      counter
                      maxlength="64"
                      hint="Altere o título do formulário, se desejar"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-tooltip location="bottom" text="Editar título">
                      <template #activator="{ props }">
                        <v-btn
                          class="mb-1"
                          color="green"
                          v-bind="props"
                          @click="editarTitulo(editedItem)"
                        >
                          Editar
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <p>Selecione uma das opções abaixo:</p>
                  </v-col>
                  <v-col cols="12">
                    <v-tooltip
                      location="bottom"
                      text="Adicionar itens de avaliação"
                    >
                      <template #activator="{ props }">
                        <v-btn
                          prepend-icon="mdi-plus"
                          class="mr-4"
                          v-bind="props"
                          @click="addQuestoesDialog = true"
                          >Adicionas itens</v-btn
                        >
                      </template>
                    </v-tooltip>
                    <v-tooltip
                      location="bottom"
                      text="Excluir itens de avaliação"
                    >
                      <template #activator="{ props }">
                        <v-btn
                          prepend-icon="mdi-delete"
                          color="red"
                          v-bind="props"
                          @click="excluirQuestoesDialog = true"
                        >
                          Excluir itens
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <!-- <small>*Campo Obrigatório</small> -->
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" variant="text" @click="editarDialog = false">
                  Fechar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!--Adicionar questões ao formulário-->
          <v-dialog v-model="addQuestoesDialog" scrollable width="900px">
            <v-card>
              <v-card-title> Adicionar Itens ao Formulário </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <p>
                        Selecione os itens que serão adicionados ao formulário:
                      </p>
                    </v-col>
                  </v-row>
                  <v-row class="my-2">
                    <v-col cols="12">
                      <v-data-table
                        v-model="pId"
                        :headers="headers2"
                        :items="itens"
                        item-value="id"
                        show-select
                        class="elevation-1"
                      >
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  variant="text"
                  @click="addQuestoesDialog = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="adicionarQuestoes()"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!--Excluir questões ao formulário-->
          <v-dialog v-model="excluirQuestoesDialog" scrollable width="900px">
            <v-card>
              <v-card-title> Excluir Itens do Formulário </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <p>
                        Selecione os itens que serão removidos do formulário:
                      </p>
                    </v-col>
                  </v-row>
                  <v-row class="my-2">
                    <v-col cols="12">
                      <v-data-table
                        v-model="pIdExc"
                        :headers="headers2"
                        :items="questoesFormExcluir"
                        item-value="id"
                        show-select
                        class="elevation-1"
                      >
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red"
                  variant="text"
                  @click="excluirQuestoesDialog = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="excluirQuestoes()"
                >
                  Salvar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!--Excluir formulário-->
          <v-dialog v-model="excluirDialog" max-width="500px">
            <v-card>
              <v-card-title>Excluir formulário</v-card-title>
              <v-card-text>
                <p>Deseja realmente excluir o este formulário?</p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" variant="text" @click="closeDelete"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="blue-darken-1"
                  variant="text"
                  @click="deleteItemConfirm"
                  >Confirmar</v-btn
                >
                <!-- <v-spacer></v-spacer> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Ver usuário
            <v-dialog v-model="dialogView" max-width="850px">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="8">
                        <v-label>Nome</v-label>
                        <p>{{ editedItem.name }}</p>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog> -->
        </v-toolbar>
      </template>
      <!-- eslint-disable -->
      <template v-slot:item.actions="{ item }">
        <v-tooltip text="Visualizar Formulário" location="bottom">
          <template #activator="{ props }">
            <v-icon v-bind="props" size="small" @click="showItem(item.raw)">
              mdi-eye
            </v-icon>
          </template>
        </v-tooltip>
        <v-tooltip text="Editar Formulário" location="bottom">
          <template #activator="{ props }">
            <v-icon v-bind="props" size="small" @click="editItem(item.raw)">
              mdi-pencil
            </v-icon>
          </template>
        </v-tooltip>
        <v-tooltip text="Excluir Formulário" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-bind="props"
              size="small"
              color="red"
              @click="deleteItem(item.raw)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-tooltip>
      </template>
      <!-- eslint-enable -->
      <template #no-data>
        <div class="text-center py-6">
          <span> Sem formulários a listar </span>
        </div>
      </template>
      <!-- <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
        </template> -->
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VDataTable } from 'vuetify/labs/VDataTable';

import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    VDataTable,
    SnackBar,
  },
  data: () => ({
    nomeFormulario: '',
    descricaoClass: '',
    idItem: 0,
    dialogView: false,
    visualizarDialog: false,
    cadastrarDialog: false,
    editarDialog: false,
    excluirDialog: false,
    addQuestoesDialog: false,
    excluirQuestoesDialog: false,
    headers: [
      {
        title: 'ID',
        align: 'start',
        key: 'id',
      },
      {
        title: 'Título',
        align: 'start',
        key: 'nome',
      },
      { title: 'Ações', align: 'start', key: 'actions', sortable: false },
    ],
    headers2: [
      {
        title: 'Itens de avaliação',
        align: 'start',
        key: 'descricao',
      },
    ],
    itens: [],
    forms: [],
    formsComQuestoes: [],
    questoesFormExcluir: [],
    listaClassificacoes: [],
    classificacoes: [],
    itensSelecionados: [], // array de perguntas que comporão o formulário
    questoesAdd: [], // array de perguntas selecionadas para serem adicionadas ao formulário
    pId: [], // arrays de perguntas disponíveis para serem inseridas no formulário
    pIdExc: [], // array de perguntas que serão removidas do formulário
    editedIndex: -1,
    editedItem: {
      nomeFormulario: '',
      id: null,
    },
    defaultItem: {
      nomeFormulario: '',
      id: null,
    },
    search: '',
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Cadastrar Item' : 'Editar Item';
    },
  },

  watch: {
    cadastrarDialog(val) {
      val || this.close();
    },
    editarDialog(val) {
      val || this.close();
    },
    visualizarDialog(val) {
      val || this.close();
    },
  },

  created() {
    this.fetchForms();
    this.fetchItems();
  },

  methods: {
    /* eslint-disable */
    /**
     * Busca usuários na API e atualiza a lista de usuários com as informações recebidas.
     * @function
     * @name fetchClassificacao
     * @returns {void}
     * @throws {Error} Se ocorrer um erro na chamada da API.
     */
    /* eslint-enable */
    fetchForms() {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };

      axios
        .get(API_URL + '/avaliacoes/formulario', config)
        .then((response) => {
          this.forms = response.data.map((formulario) => ({
            id: formulario.id_formulario,
            nome: formulario.titulo,
          }));
          console.log(this.forms);
          this.nomesforms = this.forms.map((formulario) => formulario.nome);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchItems() {
      // buscando todos os itens do back
      axios
        .get(API_URL + '/avaliacoes/listar/item', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            this.itens.push({
              id: element.id_item_de_avaliacao,
              descricao: element.descricao,
              idClass: element.id_classificacao,
              nomeClass: element.tb_classificacao.descricao,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });

      // buscando todas as classificações para aparecer no momento do cadastro
      axios
        .get(API_URL + '/avaliacoes/listar/classificacao', {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          response.data.forEach((element) => {
            this.listaClassificacoes.push({
              id: element.id_classificacao,
              descricao: element.descricao,
            });
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    adicionarQuestoes() {
      // transformando itensSelecionados em um array de json com o campo id_item_avaliacao para o backend
      const itemsQuestoesSelecionados = [];
      for (const element of this.pId) {
        // eslint-disable-next-line camelcase
        const itemJson = { id_item_de_avaliacao: element };
        itemsQuestoesSelecionados.push(itemJson);
      }
      const data = {
        // eslint-disable-next-line camelcase
        questoes: itemsQuestoesSelecionados,
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .post(
          API_URL +
            `/avaliacoes/formulario/questao/adicionar/${this.editedItem.id}`,
          data,
          config,
        )
        .then((response) => {
          console.log(response.data);

          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Item adicionado com sucesso!',
          );
          location.reload();
        })
        .catch((error) => {
          this.$refs.snackbar.showWarningSnackbar(
            'Itens já adicionados!',
            'Não foi possível adicionar os itens pois já existem no formulário!',
          );
          console.error(error);
        });
      this.addQuestoesDialog = true;
    },

    excluirQuestoes() {
      // transformando itens para exclusão em um array de json com o campo id_item_avaliacao para o backend
      const itemsQuestoesSelecionados = [];
      for (const element of this.pIdExc) {
        // eslint-disable-next-line camelcase
        const itemJson = { id_item_de_avaliacao: element };
        itemsQuestoesSelecionados.push(itemJson);
      }
      const data = {
        data: {
          // eslint-disable-next-line camelcase
          questoes: itemsQuestoesSelecionados,
        },
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      axios
        .delete(
          API_URL +
            `/avaliacoes/formulario/questao/deletar/${this.editedItem.id}`,
          data,
          config,
        )
        .then((response) => {
          console.log(response.data);

          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Item removido com sucesso!',
          );
          location.reload();
        })
        .catch((error) => {
          this.$refs.snackbar.showErrorSnackbar(
            'Erro!',
            'Não foi possível excluir os itens!',
          );
          console.error(error);
        });
      this.excluirQuestoesDialog = true;
    },

    cadastrarItem() {
      // transformando itensSelecionados em um array de json com o campo id_item_avaliacao para o backend
      const itemsAvaliacaoSelecionados = [];
      for (const element of this.itensSelecionados) {
        // eslint-disable-next-line camelcase
        const itemJson = { id_item_de_avaliacao: element };
        itemsAvaliacaoSelecionados.push(itemJson);
      }
      const data = {
        // eslint-disable-next-line camelcase
        titulo: this.nomeFormulario,
        questoes: itemsAvaliacaoSelecionados,
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      if (
        this.nomeFormulario != '' &&
        this.nomeFormulario.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ0-9\sçÇ\-_]/g, '') ===
          this.nomeFormulario
      ) {
        axios
          .post(API_URL + '/avaliacoes/formulario/cadastrar', data, config)
          .then(() => {
            this.$refs.snackbar.showSuccessSnackbar(
              'Concluído!',
              'Formulário cadastrado com sucesso!',
            );
            location.reload();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Erro!',
          'Por favor, preencha todos os campos corretamente!',
        );
      }
    },
    /**
     * Mostra o item selecionado em um dialog
     *
     * @param {Object} item - O item selecionado
     * @returns {void}
     */
    showItem(item) {
      axios
        .get(API_URL + `/avaliacoes/formulario/visualizar/${item.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.formsComQuestoes = response.data.tb_questoes_formulario.map(
            (item) => ({
              descricao: item.tb_item_de_avaliacao.descricao,
              descricaoClassificacao:
                item.tb_item_de_avaliacao.tb_classificacao.descricao,
            }),
          );
        })
        .catch((error) => {
          console.error(error);
        });
      this.editedIndex = this.forms.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.editedItem.nomeFormulario = item.nome;
      // this.editedItem.descricao = item.descricao;
      this.visualizarDialog = true;
    },

    editarTitulo(item) {
      const data = {
        titulo: item.nomeFormulario,
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.state.token}`,
        },
      };
      if (
        item.nomeFormulario != '' &&
        item.nomeFormulario.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ0-9\sçÇ\-_]/g, '') ===
          item.nomeFormulario
      ) {
        axios
          .put(
            API_URL + `/avaliacoes/atualizar/formulario/${item.id}`,
            data,
            config,
          )
          .then((response) => {
            console.log(item);
            console.log(response.data);
            this.$refs.snackbar.showSuccessSnackbar(
              'Concluído!',
              'Título editado com sucesso!',
            );
            location.reload();
          })
          .catch(() => {
            this.$refs.snackbar.showErrorSnackbar(
              'Uhm!',
              'Por algum motivo não conseguimos editar o título do formulário',
            );
          });
      } else {
        this.$refs.snackbar.showWarningSnackbar(
          'Campo vazio!',
          'Por favor, preencha o título do formulário!',
        );
      }
    },

    editItem(item) {
      // pegando as questôes do formulário
      axios
        .get(API_URL + `/avaliacoes/formulario/visualizar/${item.id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.questoesFormExcluir = response.data.tb_questoes_formulario.map(
            (item) => ({
              descricao: item.tb_item_de_avaliacao.descricao,
              id: item.tb_item_de_avaliacao.id_item_de_avaliacao,
            }),
          );
        })
        .catch((error) => {
          this.$refs.snackbar.showErrorSnackbar(
            'Erro!',
            'Não foi possível carregar os itens deste formulário para excluir!',
          );
          console.error(error);
        });
      this.editedIndex = this.forms.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.nomeFormulario = item.nome;
      this.editedItem.id = item.id;
      this.editarDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.forms.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // chamar rota de excluir formulário aqui
      this.idItem = item.id;
      this.excluirDialog = true;
    },

    deleteItemConfirm() {
      axios
        .delete(API_URL + `/avaliacoes/formulario/deletar/${this.idItem}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then(() => {
          this.forms.splice(this.editedIndex, 1);
          this.closeDelete();
          this.$refs.snackbar.showSuccessSnackbar(
            'Concluído!',
            'Formulário excluído com sucesso!',
          );
        })
        .catch((error) => {
          this.$refs.snackbar.showErrorSnackbar(
            'Erro!',
            error.response.data.error,
          );
          console.error(error);
        });
    },

    close() {
      this.cadastrarDialog = false;
      this.classSelecionada = null;
      this.nomeFormulario = '';
      this.itens.sele;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.excluirDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    // save() {
    //   if (this.editedIndex > -1) {
    //     Object.assign(this.forms[this.countID], this.editedItem);
    //   } else {
    //     const data = {
    //       descricao: this.editedItem.descricao,
    //     };

    //     const config = {
    //       headers: {
    //         'Content-Type': 'application/json',
    //         Authorization: `Bearer ${store.state.token}`,
    //       },
    //     };

    //     axios
    //       .post(API_URL + '/avaliacoes/cadastrar/item', data, config)
    //       .then((response) => {
    //         console.log(response.data);
    //         this.forms.push(this.editedItem);
    //         this.$refs.snackbar.showSuccessSnackbar(
    //           'Concluído!',
    //           'formulário cadastrada com sucesso!'
    //         );
    //       })
    //       .catch((error) => {
    //         console.error(error);
    //       });
    //   }
    //   this.close();
    // },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  width: 50%;
  align-items: center;
}
.button-config {
  background-color: #004984;
  text-transform: capitalize;
  margin-right: 40px;
  margin-left: 20px;
}

.dialog-bottom-transition-enter-active,
.dialog-bottom-transition-leave-active {
  transition: transform 0.2s ease-in-out;
}
</style>
